/*
 * Title: 승인잔액 조회 서비스
 * Author: KimHyunSoo
 * Date: 2021-04-26
 */

import GentleWidget from '../common/widget';
import GentleLang from '../common/lang';
import GentleComponentBubble from '../component/bubble';
import GentleProxy from '../common/proxy';
import language from '../lang';
import GentleUtil from '../common/util';

var GentleServiceApprove = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

// api
// 2025.3 승인잔액 조회
GentleServiceApprove.query = function(CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount, RecogDate){
    console.log('GentleServiceApprove.query');
    
    const onSuccess = function(data){
        // console.log('onSuccess>', data);
        const {result} = data;
        switch(result){
        case "200":
            const { item } = data;

            console.log('Data>', item);
            // if(StatusDetailCode === '100')
            // { // 2개 이상. 승인금액

            //     GentleServiceApprove.input(CardFirstNumber, CardLastNumber, RecogNumber);
            //     return;
            // }
            // else if(Data){
            //     // todo : 
            //     GentleServiceApprove.result(Data);
            // }
            // else{
            //     if(RecogDate === ''){
            //         // todo 
            //         const html = GentleLang.translateService(language.approve, language.approve.type.NotFound);
            //         var bubble = Object.create( GentleComponentBubble );   
            //         bubble.createComponent({
            //             html,
            //         });
            //         bubble.insert();    
            //     }
            //     else{
            //         GentleServiceApprove.result(Data);
            //     }
                GentleServiceApprove.result(item);
            // } 
            break;
        default:
            break;
        }
    };

    const onFailed = function(data){
        console.log('onFailed');        
    }
    let binAtFirst = CardFirstNumber
    let binAtLast = CardLastNumber
    let approvalNumber = RecogNumber
    const proxy = Object.create(GentleProxy);
    
    let formData = new FormData(); // new FromData()로 새로운 객체 생성
    // formData.append("binAtFirst", binAtFirst); // <input name="item" value="hi"> 와 같다.
    // formData.append("binAtLast", binAtLast);
    // formData.append("approvalNumber", approvalNumber);
    // formData.append("approvalDate", RecogDate);
    // formData.append("amount", SettleAmount);

    // formData.append("binAtFirst", "3333");
    // formData.append("binAtLast", "123*");
    // formData.append("approvalNumber", "30091195");
    // formData.append("approvalDate", "20250131");
    // formData.append("amount", "40000");
    // proxy.requestFormData("2025-cardars", formData, onSuccess, onFailed);

    const param = {
        binAtFirst: binAtFirst,
        binAtLast: binAtLast,
        approvalNumber: approvalNumber,
        approvalDate: RecogDate,
        amount: SettleAmount
    }
    proxy.requestEx({proxy:"2025-cardars", param, onSuccess, onFailed, isHidden: true});

    // const body = formDataㄴ
    // proxy.requestFormData("global-cardars", formData, onSuccess, onFailed);
}

GentleServiceApprove.main = function(){
    console.log('GentleServiceApprove.main');
    // 전역변수 처리
    const component =  Object.create(this);

    let $pre, $post, $appNumber, $comment, $button, $yData, $mData, $dData, $amNumber;

    let CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount, RecogDate;

    const render = function(data){
        // 봇버블
        {
            const html = GentleLang.translateService(language.approve, language.approve.type.BotMain);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 삽입형
        {
            const cardNumber = GentleLang.translate(GentleLang.type.CardNumber);
            const cardComment = GentleLang.translateService(language.approve, language.approve.type.CardComment);
            const approveNumber = GentleLang.translateService(language.approve, language.approve.type.Number);
            const amount = GentleLang.translateService(language.approve, language.approve.type.Amount);
            const amountDate = GentleLang.translateService(language.approve, language.approve.type.Date);
            const button_title = GentleLang.translateService(language.approve, language.approve.type.CheckRemain);

            let testValue1 = '';
            let testValue2 = '';
            let testValue3 = '';
            let yDataDefault = 'yyyy';
            let mDataDefault = 'mm';
            let dDataDefault = 'dd';
            let amountDefault = "";

            if(window.location.hostname === 'localhost'){
                testValue1 = '3562';
                testValue2 = '1706';
                testValue3 = '35621706';
                yDataDefault = '2020';
                mDataDefault = '06';
                dDataDefault = '16';
                amountDefault = '306000';
            }
            
            const html = `
            <div class="card-view">
                <form class="service-form">
                    <h3>${cardNumber}</h3>
                    <div class="card-num">
                        <input type = "text" name="pre" tabindex="1" placeholder="${testValue1}" >
                        <input type = "text" name="card_num_2" value="****" class="disabled">
                        <input type = "text" name="card_num_3" value="****" class="disabled">
                        <input type = "text" name="post" tabindex="2" placeholder="${testValue2}">
                    </div>
                    <p class="tip"><i class="at-icon at-info-gray at-3x"></i>${cardComment}</p>
                    <hr class="mt-10">
                    <h3 class="service-title">${amountDate}</h3>
                    <div class="card-num">
                        <input type = "text" name="yData" tabindex="1" placeholder="${yDataDefault}"><div>년</div>
                        <input type = "text" name="mData" tabindex="1" placeholder="${mDataDefault}"><div>월</div>
                        <input type = "text" name="dData" tabindex="2" placeholder="${dDataDefault}"><div>일</div>
                    </div>
                    <hr class="mt-10">
                    <h3 class="service-title">${amount}</h3>
                    <input type = "text" name="amNumber" tabindex="3" placeholder="${amountDefault}">
                    <hr class="mt-10">
                    <h3 class="service-title">${approveNumber}</h3>
                    <input type = "text" name="appNumber" tabindex="3" placeholder="${testValue3}">
                    <hr class="mt-10">
                    <p class="info warning" style="display:block" name="comment"></p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">${button_title}</button>
                        </div>
                    </div>
                </form>
            </div>`;

            // component 초기화. 이 코드 후에 레퍼런스로 접근
            {
                let $container = $(html)
                component.setPrefix("approve");
                component.init($container);
                component.insert();
            }

            // bind
            {
                $pre = component.find('[name="pre"]');
                $post = component.find('[name="post"]');
                $yData = component.find('[name="yData"]');
                $mData = component.find('[name="mData"]');
                $dData = component.find('[name="dData"]');
                $amNumber = component.find('[name="amNumber"]');
                $appNumber = component.find('[name="appNumber"]');
                $comment = component.find('[name="comment"]');
                $button = component.find('button');
            }
            
            // button
            component.find('button').bind('click',function() {
                    console.log('승인잔액 조회하기 > ');
                    GentleComponentBubble.insertUserBubble({html: button_title, send: false})

                    CardFirstNumber = $pre.val();
                    CardLastNumber = $post.val();
                    let YearDate = $yData.val();
                    let MonthDate = $mData.val();
                    let DayDate = $dData.val();
                    console.log(Math.abs(MonthDate))
                    if(Math.abs(MonthDate) < 10){
                        MonthDate = "0"+Math.abs(MonthDate)
                    }
                    if(Math.abs(DayDate) < 10){
                        DayDate = "0"+Math.abs(DayDate)
                    }
                    SettleAmount = $amNumber.val();
                    RecogNumber = $appNumber.val();
                    console.log("zxcv", MonthDate, DayDate)
                    RecogDate = String(YearDate)+String(MonthDate)+String(DayDate)
                    console.log(CardFirstNumber);
                    console.log(CardLastNumber);
                    console.log(RecogNumber);
                    console.log(RecogDate)
                    console.log(SettleAmount)
                    $comment.html('');
                    if(
                        $pre.val() === '' &&
                        $post.val() === '' &&
                        $appNumber.val() === '' 
                    ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputCardNumAppNum));
                        return;                        
                    }          
                    else if($appNumber.val() === '' ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputAppNum));
                        return;                        
                    }          
                    else if(
                        $pre.val() === '' ||
                        $post.val() === '' 
                    ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputCardNum));
                        return;                        
                    }else if(
                        $amNumber.val() === '' &&
                        ($yData.val() === '' ||
                        $mData.val() === '' ||
                        $dData.val() === '')
                    ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputDateAmount));
                        return;                        
                    }else if(
                        $yData.val() === '' ||
                        $mData.val() === '' ||
                        $dData.val() === ''
                    ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputDate));
                        return;                        
                    }else if($amNumber.val() === '' ){
                        $comment.html(GentleLang.translateService(language.approve, language.approve.type.InputAmount));
                        return;                        
                    }// 승인일,금액 분기처리 2023/8/11 Youn Heesang               

                    GentleServiceApprove.query(CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount, RecogDate);
                }
            );
        }
        GentleUtil.timeStamp();
    };
    render();
}

GentleServiceApprove.input = function(CardFirstNumber, CardLastNumber, RecogNumber){
    console.log('GentleServiceApprove.input');
    const component =  Object.create(this);
    let $date;
    let $amount;
    let $comment;

    const query = function(CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount='', RecogDate=''){
        console.log('GentleServiceApprove.query');
    
        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            const {Status, StatusDetailCode} = data;
            switch(Status){
            case 1:
                const { Data } = data;
    
                console.log('Data>', Data);
                if(StatusDetailCode === '100')
                { // 2개 이상. 승인금액
    
                    GentleServiceApprove.input(CardFirstNumber, CardLastNumber, RecogNumber);
                    return;
                }
                else if(Data){
                    // todo : 
                    GentleServiceApprove.result(Data);
                }
                else{
                    if(RecogDate === ''){
                        // todo 
                        const html = GentleLang.translateService(language.approve, language.approve.type.NotFound);
                        var bubble = Object.create( GentleComponentBubble );   
                        bubble.createComponent({
                            html,
                        });
                        bubble.insert();    
                    }
                    else{
                        // todo : 
                        const html = GentleLang.translateService(language.approve, language.approve.type.NotFoundData); 
                        $comment.html(html);
                    }
                } 
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');        
        }
    
        
        const proxy = Object.create(GentleProxy);

        // 2025.3
        // const param = {CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount, RecogDate};
        const param = {binAtFirst: CardFirstNumber, binAtLast: CardLastNumber, approvalNumber: RecogNumber, amount: SettleAmount, approvalDate: RecogDate};
    
        // CardFirstNumber={}&CardLastNumber={}&RecogNumber={}&SettleAmount={}&RecogDate={}",
        // 2025.3 승인잔액 조회
        proxy.request("cardars", param, onSuccess, onFailed );
    }
    
    // 봇버블
    {
        const html = GentleLang.translateService(language.approve, language.approve.type.BotComment);
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
                html,
        });
        bubble.insert();
    }

    {
        const titleDate = GentleLang.translateService(language.approve, language.approve.type.Date) ; // 하위회원 선택
        const titleAmount = GentleLang.translateService(language.approve, language.approve.type.Amount) ; // 하위회원 선택
        const buttonDate = GentleLang.translateService(language.approve, language.approve.type.SelectDate);
        const buttonQuery = GentleLang.translateService(language.approve, language.approve.type.ViewRemain);

        const html = `
        <div class="card-view">
            <form class="service-form">
                <h3>${titleDate}</h3>
                <input type = "text" name="date" value="">
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default" name="button-date">${buttonDate}</button>
                    </div>
                </div>
                <hr class="mt-20">
                <h3>${titleAmount}</h3>
                <input type = "text" name="amount" value="">
                <p class="info warning" name="comment"></p>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default" name="button-query">${buttonQuery}</button>
                    </div>
                </div>
            </form>
        </div>

        <script>
            $('input[name="date"]').setDatePicker();
            $('input[name="date"]').attr("readonly",true);
            $('[name="button-date"]').on('click', function(){
                $('input[name="date"]').focus();
            });
        </script>
        `;

        // component 초기화. 이 코드 후에 레퍼런스로 접근
        {
            let $container = $(html)
            component.setPrefix("search");
            component.init($container);
            component.insert();
        }

        // bind
        {
            $date = component.find('[name="date"]');
            $amount = component.find('[name="amount"]');
            $comment = component.find('[name="comment"]');
        }

        // button
        component.find('[name="button-date"]').bind('click',function(){
            console.log('승인일자 선택하기>', $date.val());
        });
        component.find('[name="button-query"]').bind('click',function() {
            console.log('승인잔액 조회하기>', $amount.val());
            GentleComponentBubble.insertUserBubble({html:buttonQuery, send:false})

            const RecogDate = $date.val();
            const SettleAmount = $amount.val();

            query(CardFirstNumber, CardLastNumber, RecogNumber, SettleAmount, RecogDate);
        });
    }  
};

// 2025.3 확인
GentleServiceApprove.result = function(data){
    console.log('GentleServiceApprove.result>', data);
    const component =  Object.create(this);

    const render = function(data){
        // if(!data) // 값들이 전부 Null로 들어와서 아래 조건으로 변경 2023/08/11 Youn Heesang
        if(data.orderId === null)   // not found
        {
            const html = GentleLang.translateService(language.approve, language.approve.type.NotFoundData);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
            return;
        }
        let num = 0;
        if(data.balanceAmount !== null){
             num = GentleUtil.comma(data.balanceAmount);
        }else {
             num = 0;
        }
        
        
        // 봇버블
        {
            const html = GentleLang.translateService(language.approve, language.approve.type.BotShowResult);
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    html,
            });
            bubble.insert();
        }

        // 단순 insert
        {
            const title = GentleLang.translateService(language.approve, language.approve.type.RemainResult);
            const currency = GentleLang.translate(GentleLang.type.CurrencyFormat1, {num});
            const html = 
            `<div class="card-view">
                <div class="margin-container">
                    <h3>${title}</h3>
                    <p style="text-align: right;">${currency}</p>
                </div>
            </div>
            `
            // `
            // <div style="background-color: #4CAF50;">
            //     ${title} : ${currency}
            // </div>
            // `;

            const $html = $(html);
            component.insertElement($html);
        }
        GentleUtil.timeStamp();
    };

    render(data);
};


export default GentleServiceApprove; 